module.exports = __webpack_public_path__ + "media/images/company/cp19-c0240810dbe00035b187bf9ccd28e5f5.png";